module.exports = __webpack_public_path__ + "img/blue-arrow-left.9ebd1047.svg";